<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-06 10:53:41
 * @LastEditTime: 2019-08-09 12:10:45
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="content">
        <div class="block">
            <p>1、结算之后，结算的金额将会从相应经销商的账户余额中扣除，请通过线下打款完成返利结算</p>
            <p>2、列表只显示获得返利的经销商</p>
        </div>
        <el-tabs v-model="active" type="card" @tab-click="handleClick">
            <el-tab-pane label="直属经销商" name="1">
                <el-tabs v-model="activeName1" type="card"  @tab-click="secondClick">
                    <el-tab-pane label="结算管理" name="1">
                        <el-form ref="form1" :model="form1" label-width="100px" :inline="true" class="mt20">
                            <el-form-item label="经销商:">
                                <el-col :span="16">
                                    <el-input v-model="form1.dealer_sn" clearable></el-input>
                                </el-col>
                                <el-col :span="4" style="margin-left: 10px;">
                                    <el-button type="primary" @click="selectType()">选择</el-button>
                                </el-col>
                            </el-form-item>
                             <el-form-item label="经销商级别:">
                        <el-select v-model="form1.dealer_level_id" placeholder="请选择经销商级别" clearable>
                            <el-option v-for=" (i,k) in dealerLevel" :key="k" :label="i.level_name"
                                       :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
                       
                            <el-form-item label="列表排序:">
                                <el-select v-model="form1.sort_type">
                                    <el-option  label="全部" value=""></el-option>
                                    <el-option label="按账户余额" value="1"></el-option>
                                    <el-option  label="按历史总额" value="2"></el-option>
                                    <el-option  label="按结算金额" value="3"></el-option>

                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="getList()">搜索</el-button>
                                <el-button @click="exportData()">导出</el-button>
                            </el-form-item>
                        </el-form>
                        <!--表格-->
                        <el-table
                            v-loading:loading
                                ref="multipleTable"
                                :data="tableData1"
                                border
                                stripe
                                height="350"
                                style="width: 100%;margin-top: 20px">
                            <el-table-column
                                    prop="dealer_sn"
                                    label="经销商编号"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="dealer_name"
                                    label="经销商名称"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="dealer_level_name"
                                    label="经销商级别"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="total_rebate"
                                    label="返利金额"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="total_settlement"
                                    label="结算金额"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="account_balance"
                                    label="账户余额"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop=""
                                    label="操作"
                                    show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="settlement(scope.row)">结算</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!--分页-->
                        <el-pagination
                                style="margin: 20px 0"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pageNo"
                                :page-sizes="[20, 50, 100, 200]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalSize">
                        </el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="结算记录" name="2">
                        <el-form ref="form2" :model="form1" label-width="100px" :inline="true" class="mt20">
                            <el-form-item label="经销商:">
                                <el-col :span="16">
                                    <el-input v-model="form1.dealer_sn" clearable></el-input>
                                </el-col>
                                <el-col :span="4" style="margin-left: 10px;">
                                    <el-button type="primary" @click="selectType()">选择</el-button>
                                </el-col>
                            </el-form-item>
                            
                          
                                <el-form-item label="经销商级别:">
                        <el-select v-model="form1.dealer_level_id" placeholder="请选择经销商级别" clearable>
                            <el-option v-for=" (i,k) in dealerLevel" :key="k" :label="i.level_name"
                                       :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
                            <el-form-item label="结算时间:" style="text-align: center">
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="开始时间" v-model="form1.start_time" style="width: 100%;"
                                                    clearable></el-date-picker>
                                </el-col>
                                <el-col :span="2">-</el-col>
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="结束时间" v-model="form1.end_time" style="width: 100%;"
                                                    clearable></el-date-picker>
                                </el-col>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="getHistoryList()">搜索</el-button>
                                <el-button @click="exportData1()">导出</el-button>
                            </el-form-item>
                        </el-form>
                       <el-row>
                           <span>结算金额:</span><span style="margin-left: 20px;color: red">{{total}}</span>
                       </el-row>
                        <!--表格-->
                        <el-table
                                ref="multipleTable"
                                :data="tableData1"
                                border
                                stripe
                                height="350"
                                style="width: 100%;margin-top: 20px">
                            <el-table-column
                                    prop="dealer_sn"
                                    label="经销商编号"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="dealer_name"
                                    label="经销商名称"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="dealer_level_name"
                                    label="经销商级别"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="superior_dealer_name"
                                    label="上级经销商"
                            >
                            </el-table-column>
                         
                            <el-table-column
                                    prop="settlement_money"
                                    label="结算金额"
                                    show-overflow-tooltip>
                            </el-table-column>
                       
                            <el-table-column
                                    prop="remarks"
                                    label="备注"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="operator"
                                    label="操作人"
                                    show-overflow-tooltip>
                            </el-table-column>
                        </el-table>
                        <!--分页-->
                        <el-pagination
                                style="margin: 20px 0"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pageNo"
                                :page-sizes="[20, 50, 100, 200]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalSize">
                        </el-pagination>
                    </el-tab-pane>
                </el-tabs>

            </el-tab-pane>
            <el-tab-pane label="非直属经销商" name="2">
                <el-tabs v-model="activeName2" type="card" @tab-click="secondClick1"> 
                    <el-tab-pane label="结算管理" name="1">
                       <el-form ref="form1" :model="form1" label-width="100px" :inline="true" class="mt20">
                            <el-form-item label="经销商:">
                                <el-col :span="16">
                                    <el-input v-model="form1.dealer_sn" clearable></el-input>
                                </el-col>
                                <el-col :span="4" style="margin-left: 10px;">
                                    <el-button type="primary" @click="selectType()">选择</el-button>
                                </el-col>
                            </el-form-item>
                                  <el-form-item label="经销商级别:">
                        <el-select v-model="form1.dealer_level_id" placeholder="请选择经销商级别" clearable>
                            <el-option v-for=" (i,k) in dealerLevel" :key="k" :label="i.level_name"
                                       :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
                            <el-form-item label="列表排序:">
                                <el-select v-model="form1.sort_type">
                                    <el-option  label="全部" value=""></el-option>
                                    <el-option  label="按账户余额" value="1"></el-option>
                                    <el-option label="按历史总额" value="2"></el-option>
                                    <el-option   label="按结算金额" value="3"></el-option>

                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="getList()">搜索</el-button>
                                <el-button @click="exportData()">导出</el-button>
                            </el-form-item>
                        </el-form>
                        <!--表格-->
                        <el-table
                                ref="multipleTable"
                                :data="tableData1"
                                border
                                stripe
                                height="350"
                                style="width: 100%;margin-top: 20px">
                            <el-table-column
                                    prop="dealer_sn"
                                    label="经销商编号"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="dealer_name"
                                    label="经销商名称"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="dealer_level_name"
                                    label="经销商级别"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="total_rebate"
                                    label="返利金额"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="total_settlement"
                                    label="结算金额"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="account_balance"
                                    label="账户余额"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop=""
                                    label="操作"
                                    show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="settlement(scope.row)">结算</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!--分页-->
                        <el-pagination
                                style="margin: 20px 0"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pageNo"
                                :page-sizes="[20, 50, 100, 200]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalSize">
                        </el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="结算记录" name="2">

                         <el-form ref="form1" :model="form1" label-width="100px" :inline="true" class="mt20">
                            <el-form-item label="经销商:">
                                <el-col :span="16">
                                    <el-input v-model="form1.dealer_sn" clearable></el-input>
                                </el-col>
                                <el-col :span="4" style="margin-left: 10px;">
                                    <el-button type="primary" @click="selectType()">选择</el-button>
                                </el-col>
                            </el-form-item>
                               <el-form-item label="经销商级别:">
                        <el-select v-model="form1.dealer_level_id" placeholder="请选择经销商级别" clearable>
                            <el-option v-for=" (i,k) in dealerLevel" :key="k" :label="i.level_name"
                                       :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
                            <el-form-item label="结算时间:" style="text-align: center">
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="开始时间" v-model="form1.start_time" style="width: 100%;"
                                                    clearable></el-date-picker>
                                </el-col>
                                <el-col :span="2">-</el-col>
                                <el-col :span="11">
                                    <el-date-picker type="date" placeholder="结束时间" v-model="form1.end_time" style="width: 100%;"
                                                    clearable></el-date-picker>
                                </el-col>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="getHistoryList()">搜索</el-button>
                                <el-button @click="exportData1()">导出</el-button>
                            </el-form-item>
                        </el-form>
                       <el-row>
                           <span>结算金额:</span><span style="margin-left: 20px;color: red">{{total}}</span>
                       </el-row>
                        <!--表格-->
                        <el-table
                                ref="multipleTable"
                                :data="tableData1"
                                border
                                stripe
                                height="350"
                                style="width: 100%;margin-top: 20px">
                            <el-table-column
                                    prop="dealer_sn"
                                    label="经销商编号"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="dealer_name"
                                    label="经销商名称"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="dealer_level_name"
                                    label="经销商级别"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="superior_dealer_name"
                                    label="上级经销商"
                            >
                            </el-table-column>
                        
                            <el-table-column
                                    prop="settlement_money"
                                    label="结算金额"
                                    show-overflow-tooltip>
                            </el-table-column>
                          
                            <el-table-column
                                    prop="remarks"
                                    label="备注"
                                    show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                    prop="operator"
                                    label="操作人"
                                    show-overflow-tooltip>
                            </el-table-column>
                        </el-table>
                        <!--分页-->
                        <el-pagination
                                style="margin: 20px 0"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pageNo"
                                :page-sizes="[20, 50, 100, 200]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalSize">
                        </el-pagination>
                    </el-tab-pane>
                </el-tabs>
            </el-tab-pane>
        </el-tabs>
        <!--选择经销商-->
        <selectRole
                v-if="selectRoleDialog"
                 @pushData='getRole'
                v-on:handleClose='selectRoleDialog = false'>
        </selectRole>
        <!--结算-->
        <settlementDialog
                v-if="settlementDialogVisable"
                :prop='propData'
                @pushData='getSettlement'
                v-on:handleClose='settlementDialogVisable = false'>
        </settlementDialog>

    </div>
</template>

<script>
    import selectRole from '../../common/selectDealer';
    import settlementDialog from './settlementDialog';

    export default {
        name: "rebate-manage",
        data() {
            return {
                selectRoleDialog: false,
                settlementDialogVisable: false,
                active: "1",
                activeName1: "1",
                activeName2: "1",
                loading:false,
                form1: {
                   dealer_sn:'',
                    dealer_level_id:'',
                    sort_type:''
                },
                tableData1: [
                    {},
                    {},
                ],
                pageNo: 1,
                pageSize: 10,
                totalSize: 0,
                propData:{},
                dealerLevel:[],
                total:0
            }
        },
        components: {
            selectRole,settlementDialog
        },
       
        methods: {
            //获取经销商级别
                getDealerLevel() {
                    this.$get('logistics', '/dealers.level', {}).then(res => {
                        //console.log(res);
                        this.dealerLevel = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
            getList(){    
                this.loading=true
                this.$get('logistics','/dealers.balances',{
                        is_parent:this.active,
                        page:this.pageNo,
                        per_page:this.pageSize,
                        ...this.form1
                }).then(res=>{
                   this.totalSize=res.meta.total
                    this.tableData1=res.data
                    this.total=res.total_settlement_money
                this.loading=false
                })
            },
            getHistoryList(){
                this.loading=true
                if (this.form1.start_time) {
                    this.form1.start_time = this.moment(this.form.start_time).format("YYYY-MM-DD");
                }
                if (this.form1.end_time) {
                    this.form1.end_time = this.moment(this.form.end_time).format("YYYY-MM-DD");
                }
                this.$get('logistics','/dealers.settlements.logs',{
                        is_parent:this.active,
                        page:this.pageNo,
                        per_page:this.pageSize,
                        ...this.form1
                }).then(res=>{
                   this.totalSize=res.meta.total
                    this.tableData1=res.data
                    this.total=res.total_settlement_money

                this.loading=false
                })
            },
            selectType() {
                this.selectRoleDialog = true;
            },
            getRole(data){
                this.form1.dealer_sn=data.dealer_sn
            },
            settlement(data){
                this.propData=data
                this.settlementDialogVisable = true;
            },
            handleClick(tab, event) {
                
                    this.pageNo=1;
                this.pageSize=10
                if(this.activeName1==1 ||this.activeName2==1 ){
                         this.getList()
                }else{
                    this.getHistoryList()
                }
            },
            secondClick(){
                // console.log(val)
                this.pageNo=1;
                this.pageSize=10
                // console.log(this.activeName1,this.activeName2)
             
               if(this.activeName1==1){
                this.getList()
                }else{
                    this.getHistoryList()
                }
            },
             secondClick1(){
                // console.log(val)
                this.pageNo=1;
                this.pageSize=10
             
               if(this.activeName2==1){
                this.getList()
                }else{
                    this.getHistoryList()
                }
            },
            handleCurrentChange(){
                this.handleClick()
           
            },
            handleSizeChange(){
                   this.handleClick()
           
            },
            getSettlement(val){
                console.log(val)
                var url='/dealers.balances/'+val.dealer_sn
                this.$post('logistics',url,{
                    is_parent:this.active,
                    settlement_money:parseFloat(val.settlement_money)*100 ,
                    remarks:val.remarks,
                }).then(res=>{
                    this.$message({
                        type:'success',
                        message:'结算成功',
                    })
                    this.tableData1=[]
                this.handleClick()
             
                }).catch(error=>{
                     this.$message({
                        type:'error',
                        message:error.message,
                    })
                })
            },
               //导出
    exportData() {
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");
      window.open(
       this.$Base_Export+
          "/dealers.balances.export?sort_type=" +
          this.form1.sort_type +
          "&lang=" +
          "" 
           +'&is_export=1'+
          "&dealer_level_id=" +
          this.form1.dealer_level_id +
          "&dealer_sn=" +
          this.form1.dealer_sn +       
          "&is_parent=" +
          this.active  +
          "&signature=" +
          this.$md5(access_tokens)
      );
    },
       exportData1() {
      let beginstr = "",
        endstr = "";
      if (this.form1.start_time) {
        beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD");
      }
      if (this.form1.end_time) {
        endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
      }
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");
      window.open(
        this.$Base_Export+
          "/dealers.settlements.logs.export?start_time=" +
          beginstr 
          +'&is_export=1'+
          "&end_time="+
          endstr+
          "&sort_type=" +
          this.form1.sort_type +
          "&lang="+
          "" +
          "&dealer_level_id=" +
          this.form1.dealer_level_id +
          "&dealer_sn=" +
          this.form1.dealer_sn +       
          "&is_parent=" +
          this.active+
          "&signature=" +
          this.$md5(access_tokens)
      );
    }
        },
        created() {
            this.getList()
            this.getDealerLevel()
        },
    }
</script>

<style lang="scss" scoped>
    .block {
        height: 55px;
        line-height: 24px;
        background-color: #eee;
        padding-left: 20px;
        margin-bottom: 20px;
    }

</style>